import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon';

const FiveStars = () => (
  <>
    <div>
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
    </div>
    <div>
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
      <Icon variant='star-filled' />
    </div>
  </>
);

const StarRating = ({
  className,
  percentage,
  small,
  variant,
  wrapperProps
}) => (
  <div
    className={classnames(
      'star-rating',
      variant === 'primary' && '-primary',
      small && '-small',
      className
    )}
    style={{
      '--percentage': `${percentage}%`
    }}
    {...wrapperProps}
  >
    <FiveStars />
  </div>
);

StarRating.defaultProps = {
  percentage: 0,
  small: false
};

StarRating.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf(['primary', undefined]),
  small: PropTypes.bool,
  wrapperProps: PropTypes.object
};

export default StarRating;
